(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block.product-more-designs"] && !Shopify.designMode) return;
  try {
    const initializeCaselixMoreDesigns = (container) => {
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    container.addEventListener('click', async (event) => {
      const link = event.target.closest('[data-caselix-design-link]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const productArea = container.closest('[data-section-id]') || document;
      const controls = productArea.querySelectorAll('select[name^="options["], input[name^="options["]:checked');
      const selectedValues = Array.from(controls).map((control) => control.value).filter(Boolean);
      if (!selectedValues.length) return;

      event.preventDefault();

      try {
        const destination = new URL(link.href, window.location.origin);
        const response = await fetch(`${destination.pathname}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product data unavailable');
        const targetProduct = await response.json();
        const matchingVariant = targetProduct.variants.find((variant) => selectedValues.every((value) => variant.options.includes(value)));
        if (matchingVariant) destination.searchParams.set('variant', matchingVariant.id);
        window.location.assign(destination.toString());
      } catch (error) {
        window.location.assign(link.href);
      }
    });
  };

  const initializeAllCaselixMoreDesigns = (root = document) => {
    root.querySelectorAll('[data-caselix-more-designs]').forEach(initializeCaselixMoreDesigns);
  };

  initializeAllCaselixMoreDesigns();
  document.addEventListener('shopify:section:load', (event) => initializeAllCaselixMoreDesigns(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["caselix-bundle-tabs"] && !Shopify.designMode) return;
  try {
    function initSimpleCaseSets(){
 document.querySelectorAll('[data-cx-simple-set]').forEach(root=>{
  if(root.dataset.ready)return;
  const meta=root.closest('.product-single__meta');
  if(!meta)return;
  const form=meta.querySelector('form[action*="/cart/add"]');
  const buy=meta.querySelector('block-buy-buttons');
  if(!form||!buy)return;
  const data=JSON.parse(root.querySelector('[data-set-data]').textContent);
  const labels=JSON.parse(root.querySelector('[data-set-labels]').textContent);
  const panel=root.querySelector('[data-set-panel]');
  buy.before(panel);
  buy.dataset.cxBundleHide='';
  const markHide=()=>{
   for(const el of meta.children){
    if(el.querySelector('[data-complete-look]')||el.matches('.shopify-app-block'))el.dataset.cxBundleHide='';
   }
  };
  markHide();
  const caseTab=root.querySelector('[data-set-case]');
  const bundleTab=root.querySelector('[data-set-bundle]');
  const strapSelect=panel.querySelector('[data-set-strap]');
  const protectorCheck=panel.querySelector('[data-set-protector]');
  const ringCheck=panel.querySelector('[data-set-ring]');
  const walletCheck=panel.querySelector('[data-set-wallet]');
  const strapCheck=panel.querySelector('[data-set-strap-check]');
  const button=panel.querySelector('[data-set-submit]');
  const normalize=value=>String(value||'').replace(/^Samsung\s+/i,'').replace(/\s+/g,' ').trim().toLowerCase();
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:data.currency}).format(value/100);
  const deviceIndex=Math.max(0,data.options.findIndex(name=>/model|device/i.test(name)));
  let selected,matched,strap,busy=false;
  const refresh=()=>{
   const id=String(new FormData(form).get('id')||'');
   selected=data.variants.find(variant=>String(variant.id)===id);
   strap=data.straps.find(variant=>String(variant.id)===strapSelect.value);
   const model=selected?.options?.[deviceIndex]||'';
   matched=data.protectors.find(variant=>variant.available&&(variant.options||[variant.title]).flatMap(option=>String(option).split('/')).map(normalize).includes(normalize(model)));
   panel.querySelector('[data-set-protector-row]').hidden=!matched;
   panel.querySelector('[data-set-case-variant]').textContent=selected?.title||'';
   panel.querySelector('[data-set-case-price]').textContent=selected?money(selected.price):'';
   panel.querySelector('[data-set-ring-price]').textContent=money(data.ring.price);
   if(walletCheck)panel.querySelector('[data-set-wallet-price]').textContent=money(data.wallet.price);
   panel.querySelector('[data-set-strap-price]').textContent=strap?money(strap.price):'';
   panel.querySelector('[data-set-protector-model]').textContent=model;
   panel.querySelector('[data-set-protector-price]').textContent=matched?money(matched.price):'';
   const prices=[selected?.price||0];
   if(ringCheck.checked)prices.push(data.ring.price);
   if(walletCheck?.checked)prices.push(data.wallet.price);
   if(strapCheck.checked)prices.push(strap?.price||0);
   strapSelect.disabled=!strapCheck.checked;
   if(matched&&protectorCheck.checked)prices.push(matched.price);
   const original=prices.reduce((sum,p)=>sum+p,0);
   const rate=prices.length>=4?.25:prices.length===3?.20:prices.length===2?.15:0;
   const total=prices.reduce((sum,p)=>sum+p-Math.floor(p*rate),0);
   panel.querySelector('[data-set-original]').textContent=money(original);
   panel.querySelector('[data-set-total]').textContent=money(total);
   panel.querySelector('[data-set-savings]').textContent=labels.saving.replace('[amount]',money(original-total)).replace('[percent]',String(Math.round(rate*100)));
   const magnetic=selected&&selected.options.some(option=>/mag/i.test(option));
   panel.querySelector('[data-set-note]').textContent=!selected?.available?labels.unavailable:!magnetic&&(ringCheck.checked||walletCheck?.checked)?labels.compatibility:labels.matching+(matched?'':' '+labels.noProtector);
   button.disabled=busy||!selected?.available||(ringCheck.checked&&(!magnetic||!data.ring?.available))||(walletCheck?.checked&&(!magnetic||!data.wallet?.available))||(strapCheck.checked&&!strap?.available)||prices.length<2;
  };
  const mode=bundle=>{
   markHide();meta.classList.toggle('cx-simple-bundle-mode',bundle);panel.hidden=!bundle;
   caseTab.setAttribute('aria-selected',String(!bundle));bundleTab.setAttribute('aria-selected',String(bundle));
   caseTab.tabIndex=bundle?-1:0;bundleTab.tabIndex=bundle?0:-1;refresh();
  };
  caseTab.addEventListener('click',()=>mode(false));bundleTab.addEventListener('click',()=>mode(true));
  root.querySelector('[role=tablist]').addEventListener('keydown',event=>{
   if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
   event.preventDefault();const bundle=event.key==='End'||(event.key!=='Home'&&caseTab.getAttribute('aria-selected')==='true');mode(bundle);(bundle?bundleTab:caseTab).focus();
  });
  walletCheck?.addEventListener('change',refresh);ringCheck.addEventListener('change',refresh);strapCheck.addEventListener('change',refresh);strapSelect.addEventListener('change',refresh);protectorCheck.addEventListener('change',refresh);
  meta.addEventListener('change',()=>setTimeout(refresh,100));document.addEventListener('variant:change',refresh);
  const observer=new MutationObserver(()=>{if(!panel.hidden)refresh();});
  const variantField=form.querySelector('[name=id]');if(variantField)observer.observe(variantField,{attributes:true,childList:true,subtree:true});
  const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);observer.disconnect();return;}if(!panel.hidden)refresh();},600);
  button.addEventListener('click',async()=>{
   if(busy)return;refresh();if(button.disabled)return;
   busy=true;button.disabled=true;button.textContent=labels.adding;
   panel.querySelector('[data-set-error]').textContent='';
   const reference=crypto.randomUUID();
   const properties={'_Set reference':reference};
   const items=[{id:selected.id,quantity:1,properties}];
   if(ringCheck.checked)items.push({id:data.ring.id,quantity:1,properties:{...properties,'Matching case design':data.title,'Case variant':selected.title,'_Case product':data.url}});
   if(walletCheck?.checked)items.push({id:data.wallet.id,quantity:1,properties:{...properties,'Matching case design':data.title,'Case variant':selected.title,'_Case product':data.url}});
   if(strapCheck.checked)items.push({id:strap.id,quantity:1,properties});
   if(matched&&protectorCheck.checked)items.push({id:matched.id,quantity:1,properties:{...properties,'Fits selected phone':selected.options[deviceIndex]}});
   try{
    const response=await fetch((window.Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const result=await response.json();if(!response.ok)throw new Error(result.description||labels.error);
    window.location.assign((window.Shopify.routes.root||'/')+'cart');
   }catch(error){
    panel.querySelector('[data-set-error]').textContent=labels.error;
    panel.querySelector('[data-set-cart-link]').hidden=false;
    button.textContent=labels.add;
    button.disabled=true;
   }
  });
  root.dataset.ready='true';refresh();
 });
}
initSimpleCaseSets();document.addEventListener('shopify:section:load',initSimpleCaseSets);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["caselix-cart-essentials"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cx-cart-essentials')){
 class CartEssentials extends HTMLElement{
  connectedCallback(){
   this.products=JSON.parse(this.querySelector('[data-cx-products]').textContent).filter(p=>p.id);
   this.labels=JSON.parse(this.querySelector('[data-cx-labels]').textContent);
   this.abort=new AbortController();this.busy=false;this.uncertain=false;
   this.root=window.Shopify?.routes?.root||'/';
   this.addEventListener('change',e=>{if(e.target.matches('[data-cx-source]')){const card=e.target.closest('[data-cx-offer]');const {p,source}=this.selection(card);if(p.kind===4&&source){const v=p.variants.find(v=>v.available&&(v.options||[v.title]).some(o=>this.normalize(o)===this.normalize(this.model(source))));card.querySelector('[data-cx-variant]').value=v?String(v.id):'';}}this.updateCards();});
   this.addEventListener('click',e=>{const b=e.target.closest('[data-cx-add]');if(b)this.add(b);});
   const schedule=()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.refresh(),300);};
   ['cart:updated','ajaxProduct:added','cart:build','cart:quantity'].forEach(event=>document.addEventListener(event,schedule,{signal:this.abort.signal}));
   const target=this.closest('form')?.querySelector('[data-products]');
   if(target){this.observer=new MutationObserver(schedule);this.observer.observe(target,{childList:true,subtree:true});}
   this.refresh();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearTimeout(this.timer);}
  escape(s){return String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
  money(cents){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.cart.currency}).format(cents/100);}
  model(item){const o=item.options_with_values||[];return o.find(x=>/model|size|device/i.test(x.name))?.value||'';}
  magnetic(item){return (item.options_with_values||[]).some(x=>/mag/i.test(x.value));}
  normalize(s){return String(s).replace(/^Samsung\s+/i,'').replace(/\s+/g,' ').trim().toLowerCase();}
  async refresh(){
   if(this.busy)return;
   try{const r=await fetch(this.root+'cart.js',{headers:{Accept:'application/json'}});if(!r.ok)return;this.cart=await r.json();document.querySelectorAll('[data-cart-count],.cart-link__bubble-num').forEach(n=>n.textContent=this.cart.item_count);this.hidden=!this.cart.item_count;if(this.hidden)return;
    this.cases=this.cart.items.filter(i=>/iphone|galaxy|pixel|samsung/i.test(this.model(i))&&!/protector/i.test(i.product_title));
    this.render();
   }catch{this.querySelector('[data-cx-status]').textContent=this.labels.load_error;}
  }
  render(){
   const host=this.querySelector('[data-cx-offers]');const prior=new Map([...host.querySelectorAll('[data-cx-offer]')].map(c=>[c.dataset.cxOffer,{variant:c.querySelector('[data-cx-variant]')?.value,source:c.querySelector('[data-cx-source]')?.value}]));
   host.innerHTML=this.products.map(p=>{
    const variants=p.variants.filter(v=>v.available);if(!variants.length)return '';
    const matching=p.kind<3;const sources=matching?this.cases.filter(i=>this.magnetic(i)):this.cases;
    const source=prior.get(String(p.id))?.source;
    const sourceSelect=(matching||p.kind===4)&&sources.length?`<select data-cx-source aria-label="${this.escape(this.labels.case_label)}">${sources.map(i=>`<option value="${this.escape(i.key)}" ${i.key===source?'selected':''}>${this.escape(i.product_title)} · ${this.escape(this.model(i))}</option>`).join('')}</select>`:'';
    const variantSelect=p.kind>=3?`<select data-cx-variant aria-label="${this.escape(p.kind===4?this.labels.model_label:this.labels.strap_label)}">${p.kind===4?`<option value="">${this.escape(this.labels.choose_model)}</option>`:''}${variants.map(v=>`<option value="${v.id}" ${String(v.id)===prior.get(String(p.id))?.variant?'selected':''}>${this.escape(v.title)}</option>`).join('')}</select>`:'';
    return `<article class="cx-essential" data-cx-offer="${p.id}"><a href="${this.escape(p.url)}"><img src="${this.escape(p.image)}" alt="${this.escape(p.title)}" loading="lazy" width="60" height="64"></a><div><a class="cx-essential__title" href="${this.escape(p.url)}">${this.escape(p.title)}</a><div class="cx-essential__price" data-cx-price></div>${sourceSelect}${variantSelect}<small data-cx-help></small></div><button type="button" data-cx-add aria-label="${this.escape(this.labels.add+' '+p.title)}">+</button></article>`;
   }).join('');
   for(const card of host.querySelectorAll('[data-cx-offer]')){const p=this.products.find(p=>String(p.id)===card.dataset.cxOffer);if(p.kind!==4||prior.get(String(p.id))?.variant)continue;const source=this.cases.find(i=>i.key===card.querySelector('[data-cx-source]')?.value);if(!source)continue;const v=p.variants.find(v=>v.available&&(v.options||[v.title]).some(o=>this.normalize(o)===this.normalize(this.model(source))));if(v)card.querySelector('[data-cx-variant]').value=String(v.id);}
   this.updateCards();
  }
  selection(card){const p=this.products.find(p=>String(p.id)===card.dataset.cxOffer);const v=p.kind<3?p.variants.find(v=>v.available):p.variants.find(v=>String(v.id)===card.querySelector('[data-cx-variant]')?.value);const source=this.cases.find(i=>i.key===card.querySelector('[data-cx-source]')?.value);return {p,v,source};}
  updateCards(){
   for(const card of this.querySelectorAll('[data-cx-offer]')){const {p,v,source}=this.selection(card);const matching=p.kind<3;const existing=v&&this.cart.items.some(i=>String(i.variant_id)===String(v.id)&&(!matching||i.properties?.['Matching case design']===source?.product_title));
    card.querySelector('[data-cx-price]').textContent=v?this.money(v.price):'';
    card.querySelector('[data-cx-help]').textContent=existing?this.labels.in_bag:matching?source?this.labels.matches.replace('[design]',source.product_title):this.labels.compatibility:p.kind===4?this.labels.check_model:'';
    const b=card.querySelector('button');b.disabled=this.busy||this.uncertain||!v||existing||(matching&&!source);b.textContent=existing?'✓':'+';
   }
  }
  async add(button){
   if(this.busy||this.uncertain||button.disabled)return;const {p,v,source}=this.selection(button.closest('[data-cx-offer]'));if(!v||p.kind<3&&!source)return;
   this.busy=true;this.updateCards();button.textContent='…';const status=this.querySelector('[data-cx-status]');status.textContent='';
   const properties=p.kind<3?{'Matching case design':source.product_title,'Case variant':source.variant_title,'_Case product':source.url}:{};
   let added=false;
   try{const r=await fetch(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties}]})});if(!r.ok)throw new Error('Add failed');added=true;status.textContent=this.labels.added;
    document.dispatchEvent(new CustomEvent('cart:build'));document.dispatchEvent(new CustomEvent('cart:updated'));
   }catch{this.uncertain=true;status.textContent=this.labels.error;}
   finally{this.busy=false;if(added)await this.refresh();else this.updateCards();}
  }
 }
 customElements.define('cx-cart-essentials',CartEssentials);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["caselix-matching-grip-addon"] && !Shopify.designMode) return;
  try {
    function initMatchingGripAddons(){
 document.querySelectorAll('[data-look-grip]').forEach(card=>{
  if(card.dataset.gripReady)return;
  const grid=card.closest('.product-grid__container');
  const form=grid?.querySelector('.product-single__meta form[action*="/cart/add"]');
  if(!form)return;
  card.dataset.gripReady='true';
  const data=JSON.parse(card.querySelector('[data-grip-addon-data]').textContent);
  const button=card.querySelector('[data-grip-add]');
  const status=card.querySelector('[data-grip-status]');
  let selected,busy=false,uncertain=false,addedVariant='';
  const refresh=()=>{
   selected=data.variants.find(variant=>String(variant.id)===String(new FormData(form).get('id')));
   if(busy||uncertain)return;
   const magnetic=selected?.options.some(value=>/mag/i.test(value));
   const added=String(selected?.id)===addedVariant;
   button.disabled=!selected?.available||!magnetic||added;
   button.textContent=added?data.added:data.add;
   status.textContent=added?data.success:!selected?.available?data.unavailable:!magnetic?data.compatibility:'';
  };
  form.closest('.product-single__meta').addEventListener('change',()=>setTimeout(refresh,120));
  document.addEventListener('variant:change',refresh);
  const timer=setInterval(()=>{if(!card.isConnected){clearInterval(timer);return;}refresh();},600);
  button.addEventListener('click',async()=>{
   if(busy||uncertain)return;refresh();if(button.disabled)return;
   const variant=selected;
   busy=true;button.disabled=true;button.textContent=data.adding;status.textContent='';
   try{
    const response=await fetch((window.Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:data.id,quantity:1,properties:{'Matching case design':data.title,'Case variant':variant.title,'_Case product':data.url}}]})});
    if(!response.ok)throw new Error('Grip add failed');
    addedVariant=String(variant.id);
    const cartResponse=await fetch((window.Shopify.routes.root||'/')+'cart.js');
    if(cartResponse.ok){
     const cart=await cartResponse.json();
     document.querySelectorAll('[data-cart-count], .cart-link__bubble-num').forEach(node=>{node.textContent=cart.item_count;});
     document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
     document.dispatchEvent(new CustomEvent('cart:build',{detail:{cart}}));
    }
   }catch(error){
    if(!addedVariant){uncertain=true;status.textContent=data.error;}
   }finally{busy=false;refresh();}
  });
  refresh();
 });
}
initMatchingGripAddons();document.addEventListener('shopify:section:load',initMatchingGripAddons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["caselix-matching-wallet-addon"] && !Shopify.designMode) return;
  try {
    function initMatchingWalletAddons(){
 document.querySelectorAll('[data-look-wallet]').forEach(card=>{
  if(card.dataset.walletReady)return;
  const grid=card.closest('.product-grid__container');
  const form=grid?.querySelector('.product-single__meta form[action*="/cart/add"]');
  if(!form)return;
  card.dataset.walletReady='true';
  const data=JSON.parse(card.querySelector('[data-wallet-addon-data]').textContent);
  const button=card.querySelector('[data-wallet-add]');
  const status=card.querySelector('[data-wallet-status]');
  let selected,busy=false,uncertain=false,addedVariant='';
  const refresh=()=>{
   selected=data.variants.find(variant=>String(variant.id)===String(new FormData(form).get('id')));
   if(busy||uncertain)return;
   const magnetic=selected?.options.some(value=>/mag/i.test(value));
   const added=String(selected?.id)===addedVariant;
   button.disabled=!selected?.available||!magnetic||added;
   button.textContent=added?data.added:data.add;
   status.textContent=added?data.success:!selected?.available?data.unavailable:!magnetic?data.compatibility:'';
  };
  form.closest('.product-single__meta').addEventListener('change',()=>setTimeout(refresh,120));
  document.addEventListener('variant:change',refresh);
  const timer=setInterval(()=>{if(!card.isConnected){clearInterval(timer);return;}refresh();},600);
  button.addEventListener('click',async()=>{
   if(busy||uncertain)return;refresh();if(button.disabled)return;
   const variant=selected;
   busy=true;button.disabled=true;button.textContent=data.adding;status.textContent='';
   try{
    const response=await fetch((window.Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:data.id,quantity:1,properties:{'Matching case design':data.title,'Case variant':variant.title,'_Case product':data.url}}]})});
    if(!response.ok)throw new Error('Wallet add failed');
    addedVariant=String(variant.id);
    const cartResponse=await fetch((window.Shopify.routes.root||'/')+'cart.js');
    if(cartResponse.ok){
     const cart=await cartResponse.json();
     document.querySelectorAll('[data-cart-count], .cart-link__bubble-num').forEach(node=>{node.textContent=cart.item_count;});
     document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
     document.dispatchEvent(new CustomEvent('cart:build',{detail:{cart}}));
    }
   }catch(error){
    if(!addedVariant){uncertain=true;status.textContent=data.error;}
   }finally{busy=false;refresh();}
  });
  refresh();
 });
}
initMatchingWalletAddons();document.addEventListener('shopify:section:load',initMatchingWalletAddons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["caselix-purchase-proof"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('caselix-purchase-proof')) {
    customElements.define('caselix-purchase-proof', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.slides = [...this.querySelectorAll('[data-proof-slide]')];
        this.index = 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.controls = this.querySelector('[data-proof-controls]');
        this.pauseButton = this.querySelector('[data-proof-pause]');
        this.controls.hidden = this.slides.length < 2;
        this.querySelector('[data-proof-prev]').addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-proof-next]').addEventListener('click', () => this.show(this.index + 1));
        this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
        this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.sync(); } });
        this.querySelector('[data-proof-reviews]').addEventListener('click', e => {
          const target = document.querySelector('#jdgm-tabpanel_all_reviews, #judgeme_product_reviews, .jdgm-review-widget');
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' }); }
        });
        this.visibilityHandler = () => this.sync();
        document.addEventListener('visibilitychange', this.visibilityHandler);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
        this.observer.observe(this);
        this.sync();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.querySelector('[data-proof-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
        this.sync();
      }
      sync() {
        clearInterval(this.timer);
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.pauseButton.firstElementChild.textContent = this.paused ? '▷' : 'Ⅱ';
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) this.timer = setInterval(() => this.show(this.index + 1), 8000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.visibilityHandler);
        this.ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["caselix.cart-model-verification"] && !Shopify.designMode) return;
  try {
    const confirmationStorageKey = 'caselix-confirmed-cart-models';

  const initializeModelVerification = (component) => {
    if (component.dataset.initialized === 'true') return;
    component.dataset.initialized = 'true';

    const form = component.closest('form');
    const products = form?.querySelector('[data-products]');
    const list = component.querySelector('[data-caselix-verification-list]');
    const mixedNotice = component.querySelector('[data-caselix-mixed-models]');
    const checkbox = component.querySelector('[data-caselix-model-confirmation]');
    const error = component.querySelector('[data-caselix-verification-error]');
    if (!form || !products || !list || !mixedNotice || !checkbox || !error) return;

    let signature = '';

    const setConfirmedState = (confirmed) => {
      form.classList.toggle('caselix-model-verification-confirmed', confirmed);
      component.classList.toggle('is-error', !confirmed && !error.hidden);
      if (confirmed) {
        error.hidden = true;
        component.classList.remove('is-error');
        sessionStorage.setItem(confirmationStorageKey, signature);
      } else if (sessionStorage.getItem(confirmationStorageKey) === signature) {
        sessionStorage.removeItem(confirmationStorageKey);
      }
    };

    const buildList = () => {
      const cartItems = Array.from(products.querySelectorAll('[data-caselix-verifiable="true"]'));
      list.replaceChildren();

      if (!cartItems.length) {
        component.hidden = true;
        form.classList.remove('caselix-model-verification-required', 'caselix-model-verification-confirmed');
        return;
      }

      const itemData = cartItems.map((item) => ({
        key: item.dataset.key || '',
        title: item.dataset.caselixTitle || '',
        model: item.dataset.caselixModel || '',
        modelLabel: item.dataset.caselixModelLabel || '',
        quantity: item.querySelector('[name="updates[]"]')?.value || item.dataset.caselixQuantity || '1',
        url: item.dataset.caselixReviewUrl || '#'
      }));

      signature = itemData.map((item) => `${item.key}:${item.quantity}:${item.model}`).join('|');
      const confirmed = sessionStorage.getItem(confirmationStorageKey) === signature;

      itemData.forEach((item) => {
        const row = document.createElement('li');
        row.className = 'caselix-model-verification__item';

        const details = document.createElement('div');
        const productName = document.createElement('span');
        productName.className = 'caselix-model-verification__product';
        productName.textContent = item.title;

        const model = document.createElement('span');
        model.className = 'caselix-model-verification__model';
        model.textContent = `${item.modelLabel}: ${item.model} · ${component.dataset.quantityLabel} ${item.quantity}`;

        const review = document.createElement('a');
        review.className = 'caselix-model-verification__review';
        review.href = item.url;
        review.textContent = component.dataset.reviewLabel;

        details.append(productName, model);
        row.append(details, review);
        list.append(row);
      });

      const uniqueModels = new Set(itemData.map((item) => item.model.toLowerCase()));
      mixedNotice.hidden = uniqueModels.size < 2;
      component.hidden = false;
      form.classList.add('caselix-model-verification-required');
      checkbox.checked = confirmed;
      error.hidden = true;
      component.classList.remove('is-error');
      setConfirmedState(confirmed);
    };

    checkbox.addEventListener('change', () => setConfirmedState(checkbox.checked));

    form.addEventListener('submit', (event) => {
      if (component.hidden || checkbox.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      error.hidden = false;
      component.classList.add('is-error');
      component.scrollIntoView({ behavior: 'smooth', block: 'center' });
      checkbox.focus({ preventScroll: true });
    }, true);

    new MutationObserver(buildList).observe(products, { childList: true, subtree: true });
    buildList();
  };

  const initializeAllModelVerification = (root = document) => {
    root.querySelectorAll('[data-caselix-model-verification]').forEach(initializeModelVerification);
  };

  initializeAllModelVerification();
  document.addEventListener('shopify:section:load', (event) => initializeAllModelVerification(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super()
      this.select = null
      this.buttonText = null
      this.button = null
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select')
      this.button = this.querySelector('.element-button')

      if (this.select && this.button) {
        this.init()
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-text') || this.button.querySelector('[data-button-text]')

      // Set initial text
      this.updateButtonText()

      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e))

      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e))

      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText())

      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus())
      this.select.addEventListener('blur', () => this.handleBlur())
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault()
      e.stopPropagation()

      // Trigger the native select
      this.select.focus()
      this.select.click()
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault()
          this.select.click()
          break
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break
        default:
          // Let other keys pass through
          break
      }
    }

    updateButtonText() {
      if (!this.buttonText) return

      const selectedOption = this.select.options[this.select.selectedIndex]
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option'
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused')
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused')
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e))
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e))
        this.select.removeEventListener('change', () => this.updateButtonText())
        this.select.removeEventListener('focus', () => this.handleFocus())
        this.select.removeEventListener('blur', () => this.handleBlur())
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["footer-payments"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-footer-model-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      if (event.currentTarget.value) {
        window.location.assign(event.currentTarget.value);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.customer"] && !Shopify.designMode) return;
  try {
    class FormCustomer extends HTMLElement {
    static emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

    connectedCallback() {
      this.controller?.abort()
      const { signal } = (this.controller = new AbortController())

      const form = this.querySelector('form')
      const input = form?.querySelector('input[name="contact[email]"]')
      if (!input) return

      const validate = () => {
        const ok = FormCustomer.emailPattern.test(input.value.trim())
        input.setCustomValidity(ok ? '' : this.dataset.invalidMessage)
      }

      input.addEventListener('input', validate, { signal })
      form.addEventListener(
        'submit',
        (e) => {
          validate()
          if (!form.reportValidity()) e.preventDefault()
        },
        { signal, passive: false }
      )
    }

    disconnectedCallback() {
      this.controller?.abort()
    }
  }

  customElements.define('form-customer', FormCustomer)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.form = this.querySelector('form')
      this.submitButton = this.findSubmitButton()
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]')
      return submitButton
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true
        this.submitButton.classList.add('product-form__submit-button--pulsing')
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false
        this.submitButton.classList.remove('product-form__submit-button--pulsing')
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault()

      // Disable submit button and start pulsing
      this.disableSubmitButton()

      // Get cart state before form submission
      let cartBeforeSubmission
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
        cartBeforeSubmission = await cartResponse.json()
      } catch (error) {
        console.error('Failed to get cart state before submission:', error)
        cartBeforeSubmission = null
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }

      const formData = new FormData(this.form)

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData
          },
          cancelable: true
        })
      )

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise((resolve) => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve)
      })

      config.body = formData

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      })

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent)
      let responseData

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse()
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config)
          responseData = await response.json()

          if (!response.ok) {
            throw responseData
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
        const cartAfterSubmission = await cartResponse.json()

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            }
          })
        )

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              }
            })
          )
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        })

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent)

        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            }
          })
        )
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton()
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject }

        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver
            reject(new Error('Cart request timeout - no response received from subscriber'))
          }
        }, 30000) // 30 second timeout

        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout
      })
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout)
        this._cartRequestResolver.resolve(responseData)
        delete this._cartRequestResolver
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout)
        this._cartRequestResolver.reject(error)
        delete this._cartRequestResolver
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter)
    }
  }

  customElements.define('product-form', ProductForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super()

      // Pull localized error message from data attributes
      this.formId = this.dataset.formId
      this.defaultErrorMessage = this.dataset.error
      this.defaultSuccessMessage = this.dataset.success

      // Create abort controller for event cleanup
      this.abortController = new AbortController()
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate()
      this.bindEvents()
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort()
    }

    cacheTemplate() {
      const template = this.querySelector('template')
      if (template) {
        this.template = template.innerHTML
        this.templateElement = template
      }
    }

    bindEvents() {
      const { signal } = this.abortController

      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal })

      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal })

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal })
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      this.clearMessages()
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      let message = this.defaultSuccessMessage

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      })

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent)

      if (eventCancelled) {
        return
      }

      this.showMessage(successMessageEvent.detail.message)
    }

    handleError(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      const error = e.detail.error
      let message = this.defaultErrorMessage

      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description
      } else if (error.message) {
        message = error.message
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      })

      const eventCancelled = !this.dispatchEvent(errorMessageEvent)

      if (eventCancelled) {
        return
      }

      this.showMessage(errorMessageEvent.detail.message)
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages()
      this.classList.remove('hide')

      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message)

        // Insert the error message content
        this.innerHTML = messageContent
      }
    }

    clearMessages() {
      this.classList.add('hide')

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-grid', LayoutGrid)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-stack', LayoutStack)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }

    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    function animateWithClass(element, className) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return Promise.resolve()
    }

    return new Promise((resolve) => {
      function handleAnimationEnd(event) {
        if (event.target === element) {
          element.removeEventListener('animationend', handleAnimationEnd)
          element.classList.remove(className)
          resolve()
        }
      }
      element.addEventListener('animationend', handleAnimationEnd)
      element.classList.add(className)
    })
  }

  class OverlayDrawer extends HTMLElement {
    #dialog = null
    #originalTrigger = null
    #abortController = null

    connectedCallback() {
      this.#dialog = this.querySelector('dialog')
      if (!this.#dialog) return

      this.#abortController = new AbortController()
      const { signal } = this.#abortController

      this.#dialog.addEventListener('cancel', (e) => this.#handleCancel(e), { signal })
      this.#dialog.addEventListener('click', (e) => this.#handleClick(e), { signal })
      this.#dialog.addEventListener('pointerdown', (e) => this.#handlePointerDown(e), { signal })
    }

    disconnectedCallback() {
      this.#abortController?.abort()
    }

    get lightDismiss() {
      return this.getAttribute('light-dismiss') !== 'false'
    }

    async show() {
      if (this.#dialog.open) return

      const showEvent = new CustomEvent('drawer:show', {
        bubbles: true,
        cancelable: true
      })
      this.dispatchEvent(showEvent)
      if (showEvent.defaultPrevented) return

      this.#originalTrigger = document.activeElement
      this.#dialog.showModal()

      await animateWithClass(this.#dialog, 'overlay-drawer--show')

      requestAnimationFrame(() => {
        // Only set focus if nothing inside the dialog is already focused
        if (!this.#dialog.contains(document.activeElement)) {
          const elementToFocus = this.#dialog.querySelector('[autofocus]')
          elementToFocus?.focus() ?? this.#dialog.focus()
        }
      })

      this.dispatchEvent(new CustomEvent('drawer:after-show', { bubbles: true }))
    }

    async hide(source = this) {
      if (!this.#dialog.open) return

      const hideEvent = new CustomEvent('drawer:hide', {
        bubbles: true,
        cancelable: true,
        detail: { source }
      })
      this.dispatchEvent(hideEvent)

      if (hideEvent.defaultPrevented) {
        await animateWithClass(this.#dialog, 'overlay-drawer--pulse')
        return
      }

      await animateWithClass(this.#dialog, 'overlay-drawer--hide')
      this.#dialog.close()

      if (this.#originalTrigger?.focus) {
        setTimeout(() => {
          try {
            this.#originalTrigger.focus({ preventScroll: true })
          } catch {
            this.#originalTrigger.focus()
          }
        }, 0)
      }

      this.dispatchEvent(new CustomEvent('drawer:after-hide', { bubbles: true }))
    }

    #handleCancel(event) {
      event.preventDefault()
      this.hide(this)
    }

    #handleClick(event) {
      const closeButton = event.target.closest('[data-drawer="close"]')
      if (closeButton) {
        event.stopPropagation()
        this.hide(closeButton)
      }
    }

    async #handlePointerDown(event) {
      if (event.target !== this.#dialog) return

      const rect = this.#dialog.getBoundingClientRect()
      const isClickInsideDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom

      if (!isClickInsideDialog) {
        if (this.lightDismiss) {
          this.hide(this)
        } else {
          await animateWithClass(this.#dialog, 'overlay-drawer--pulse')
        }
      }
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer)

  // Global trigger handler
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-drawer]')
    if (!trigger) return

    const attr = trigger.getAttribute('data-drawer')
    if (!attr) return

    const [command, id] = attr.trim().split(/\s+/)

    if (command === 'open' && id) {
      const drawer = document.getElementById(id)
      if (drawer?.tagName === 'OVERLAY-DRAWER') {
        event.preventDefault()
        drawer.show()
      }
    }
  })

  // Safari fix for backdrop clicks
  document.body.addEventListener('pointerdown', () => {})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map()
    // Track which groups have been prefetched
    static prefetchedGroups = new Set()

    constructor() {
      super()
      this.trigger = null
      this.template = null
      this.overlay = null
      this.closeBtn = null
      this.prevBtn = null
      this.nextBtn = null
      this.group = this.dataset.group
      this.groupItems = []
      this.currentIndex = 0

      // Register this instance
      if (this.group) {
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, [])
        }
        OverlayLightbox.registry.get(this.group).push(this)
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger')
      this.template = this.querySelector('.overlay-lightbox__template')
      this.init()
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault()
          this.openLightbox()
        })
      }

      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox()
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault()
            this.navigateToPrevious()
          } else if (e.key === 'ArrowRight') {
            e.preventDefault()
            this.navigateToNext()
          }
        }
      })
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay()
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open')
      document.body.style.overflow = 'hidden'

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems()

        // Prefetch images for the group
        this.prefetchGroupImages()

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item')
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item')
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item')
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found')
        return
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay')

      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template')
        return
      }

      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close')
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev')
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next')

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.closeLightbox()
        })
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.navigateToPrevious()
        })
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.navigateToNext()
        })
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox()
          }
        })
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay)
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open')
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item')

        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay)
          this.overlay = null
          this.closeBtn = null
          this.prevBtn = null
          this.nextBtn = null
        }
      }

      document.body.style.overflow = ''
    }

    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || []
      this.currentIndex = this.groupItems.indexOf(this)
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return

      let targetIndex = this.currentIndex - 1
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1
      }

      const targetLightbox = this.groupItems[targetIndex]
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox)
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return

      let targetIndex = this.currentIndex + 1
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0
      }

      const targetLightbox = this.groupItems[targetIndex]
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox)
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox()

      // Open target lightbox immediately
      targetLightbox.openLightbox()
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group)

        this.groupItems.forEach((lightbox) => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img')
          images.forEach((img) => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img)
          })
        })
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map((src) => src.trim().split(' ')[0])
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src
        let largestSize = 0

        srcsetUrls.forEach((url) => {
          const size = this.extractImageSize(url)
          if (size > largestSize) {
            largestSize = size
            largestUrl = url
          }
        })

        this.prefetchImage(largestUrl)
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src)
        this.prefetchImage(largestUrl)
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url)

        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0
        }

        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_')
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/)
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0
          }
        }
      } catch (e) {
        // URL parsing failed
      }

      return 0
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl)

        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400')
          return url.toString()
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_')
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg'
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension
            url.pathname = newPath
            return url.toString()
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }

      return originalUrl
    }

    prefetchImage(url) {
      const prefetchImg = new Image()
      prefetchImg.src = url
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open')
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group)
        if (groupItems) {
          const index = groupItems.indexOf(this)
          if (index > -1) {
            groupItems.splice(index, 1)
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group)
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super()
      this.cache = new Map() // Cache for pre-fetched content
      this.activeRequests = new Map() // Track active fetch requests
      this.loadingTimeout = null // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document

      this.addEventListener('change', (event) => this.onVariantChange(event))
      this.addEventListener('mouseover', (event) => this.onMouseOver(event))
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading')
      }, 200)
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = null
      }

      // Remove loading animation
      this.classList.remove('product-hot-reload--loading')
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form')
      const sectionId = this.dataset.sectionId

      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId

      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl
        optionValueId = input.dataset.optionValueId
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex]
        newProductUrl = selectedOption.dataset.productUrl
        optionValueId = selectedOption.dataset.optionValueId
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = []

      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'))
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean)

      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'))
      selects.forEach((select) => {
        const selectedOption = select.options[select.selectedIndex]
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId)
        }
      })

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter((id) => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`)
          return input && input.name !== currentOptionName
        })
        // Add the hovered option value
        selectedOptionValues.push(optionValueId)
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : ''
      return `${newProductUrl}?section_id=${sectionId}${params}`
    }

    onMouseOver(event) {
      const label = event.target.closest('label')
      if (!label) return

      const input = label.querySelector('input[type="radio"]')
      if (!input) return

      // Don't pre-fetch if already selected
      if (input.checked) return

      const requestUrl = this.buildRequestUrl(input)

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl)
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          this.cache.set(requestUrl, html)
          this.activeRequests.delete(requestUrl)
          return html
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl)
          throw error
        })

      this.activeRequests.set(requestUrl, fetchPromise)
      return fetchPromise
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return

      const optionValueElement = event.target
      const requestUrl = this.buildRequestUrl(optionValueElement)
      const oldProductUrl = this.dataset.productUrl

      // Get new product URL from the input or selected option
      let newProductUrl
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex]
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl
      } else {
        newProductUrl = oldProductUrl
      }

      // Start loading state immediately on change event
      this.showLoadingState()

      let html

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl)
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl)
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl)
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id)
      } catch (error) {
        console.error('Error updating product content:', error)
      } finally {
        // Always hide loading state
        this.hideLoadingState()
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id)

      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML
          this.dataset.productUrl = updatedHtml.dataset.productUrl
          this.dataset.variantId = updatedHtml.dataset.variantId
        })

        // Wait for the transition to complete
        await transition.finished
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML
        this.dataset.productUrl = updatedHtml.dataset.productUrl
        this.dataset.variantId = updatedHtml.dataset.variantId
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin)

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href)
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value)
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId)

      // Push new state to browser history
      window.history.pushState({}, '', url.toString())

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus()
    }
  }

  customElements.define('product-hot-reload', ProductHotReload)
  } catch(e) { console.error(e); }
})();

})();
